// @flow

import withForm from './hoc/withForm'

export default {
  withForm,
}
